import Vue from 'vue'
import {storage} from '../firebase'
import imageCompression from 'browser-image-compression';


export default {
    namespaced: true,
    state: {
        isUploading: false,
        uploadStatus: 0,
        cancelPdfUpload: false
    },
    mutations: {
        setIsUploading(state, value){
            state.isUploading = value
        },
        setUploadStatus(state, value){
            state.uploadStatus = value
        },
        cancelPdfUpload(state, value){
            state.cancelPdfUpload = value
            state.isUploading = false
            state.uploadStatus = 0
        }
    },
    actions: {
        async uploadImageAndGetUrl(context, {directory, image}){
            try{
                const ref = storage.ref().child(directory)
                const imageCompress = await imageCompression(image, {maxSizeMB: 1, maxWidthOrHeight: 1920, useWebWorker: true})
                await ref.put(imageCompress)
                return ref.getDownloadURL()
            }catch(error){
                console.error(error)
            }
        },
        uploadPdfAndGetUrl({commit, state}, {directory, pdf}){
            return new Promise((resolve, reject)=>{
                try{
                    const ref = storage.ref().child(directory)
                    const submit = ref.put(pdf)
                    commit('cancelPdfUpload', false)
                    commit('setIsUploading', true)
                    submit.on('state_changed', (snapshot)=>{
                        var progress = (snapshot.bytesTransferred / snapshot.totalBytes ) * 100
                        if(state.cancelPdfUpload){
                            Vue.$toast.error('La carga del PDF fue cancelada')
                            submit.cancel()
                        }
                        commit('setUploadStatus', progress)
                    },()=>{},async()=>{
                        commit('setIsUploading', false)
                        resolve(submit.snapshot.ref.getDownloadURL())
                    })
                }catch(error){
                    console.error(error)
                    reject(error)
                }
            })
        },
        async deleteFileFromUrl(context, url){
            const fileRef = await storage.refFromURL(url)
            fileRef.delete()
        }
    },
}